import React from 'react';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { CONTAINER_ID } from './recaptchaTarget';
import { RECAPTCHA_SITE_KEY } from '../../config';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export const RecaptchaProvider: React.FC = ({ children }) => {
  if (isFeatureEnabled(Features.recaptchaPosition)) {
    return (
      <GoogleReCaptchaProvider
        useRecaptchaNet
        useEnterprise
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        scriptProps={{ async: true, defer: true, appendTo: 'head' }}
        container={{
          element: CONTAINER_ID,
          parameters: {
            badge: 'bottomright',
          },
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    );
  }

  return <>{children}</>;
};
